import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core';
import { Form } from 'src/app/services/forms/form';
import { EbService } from '../../eb.service';

@Component({
  selector: 'eb-main-s6',
  templateUrl: './eb-main-s6.component.html',
  styleUrls: ['./eb-main-s6.component.scss']
})
/**
 * Component responsible for handling the logic and UI for section 6 of the EB main workflow.
 *
 * @remarks
 * - Monitors changes to input properties and updates the `closeDisabled` state based on the workflow table's section 5 signatures.
 * - Emits a loading event to notify parent components of loading state changes.
 *
 * @example
 * ```html
 * <app-eb-main-s6
 *   [form]="form"
 *   [disabled]="isDisabled"
 *   [showAmendment]="showAmendment"
 *   (loading)="onLoading($event)">
 * </app-eb-main-s6>
 * ```
 *
 * @input form - The workflow form data, including workflow table and sections.
 * @input disabled - Indicates if the component should be rendered in a disabled state.
 * @input showAmendment - Controls the display of amendment-related UI.
 * @output loading - Emits a boolean indicating the loading state.
 *
 * @property closeDisabled - Indicates if the close action should be disabled based on section 5 signatures.
 *
 * @see {@link OnChanges}
 */
export class EbMainS6Component implements OnChanges {

  @Input() form?: Form | null;
  @Input() disabled!: boolean;
  @Input() showAmendment!: boolean;
  @Input() service?: EbService;


  //@Output() loading = new EventEmitter<boolean>()

  closeDisabled?: boolean;

  /**
   * Lifecycle hook that is called when any data-bound property of a directive changes.
   * Updates the `closeDisabled` property based on the current state of the form's workflow table.
   * Specifically, it checks if there is a section with number 5 and if any of its signatures are enabled but not signed.
   *
   * @param changes - An object of key/value pairs for the set of changed properties.
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.closeDisabled = this.form?.wfTable?.wfTableLocal?.wfSectionLocals.find(s => s.number == 5)?.wfSignatures?.some((x) => x.enabled && !x.signed);
  }

}
